import { UnauthorizedWrapper } from './Unauthorized.styles';
import useMsal from '../../auth/useMsal';
import { useAuthStore } from '../../context/AuthContext';
import { useToast } from '../../app/useToast';

const Unauthorized = () => {
    const { logoutAzAd } = useMsal();
    const { loggedInUser } = useAuthStore();
    const { toastError } = useToast();

    const handleLogout = async (): Promise<void> => {
        try {
            await logoutAzAd();
        } catch (error) {
            console.error('[Unauthorized] Sign out failed.', error);
            toastError('Sign out failed. Please try again.', 8000);
        }
    };

    return (
        <UnauthorizedWrapper>
            <h1>Access Denied</h1>
            <div className="message-section">
                <p>
                    <strong>{loggedInUser?.userName || loggedInUser?.fullName || 'You'}</strong> do
                    {loggedInUser?.userName || loggedInUser?.fullName ? 'es' : ''} not have permission to access OrcaWeb.
                </p>
            </div>

            <div className="contact-info">
                <h3>Need Help?</h3>
                <p>
                    If you believe this is an error, please contact <a href="mailto:odfjell@helpdesk.com">odfjell@helpdesk.com</a>
                </p>
                <p>Make sure to include your username and the time you attempted to access the system.</p>
            </div>

            <button onClick={handleLogout}>Sign Out</button>
        </UnauthorizedWrapper>
    );
};

export default Unauthorized;
